import { defineMessages } from 'react-intl';

type MessageKeys = 'label';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.mentionButton.label',
		defaultMessage: 'Mention someone or a team',
		description: 'Mention button label within the Prompt screen',
	},
});

export default message;
